import { render, staticRenderFns } from "./merList.vue?vue&type=template&id=7060c88e"
import script from "./merList.vue?vue&type=script&lang=js"
export * from "./merList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports